import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchGenerateReconId = (params = {}) => {
  const query_string = new URLSearchParams(params).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/paymentreconmain/generate-reconid?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchAllPaymentReconMains = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/paymentreconmain?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchLatestPaymentReconMain = (filters = {}) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/paymentreconmain/latest`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOnePaymentReconMain = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/paymentreconmain/${encodeURIComponent(id)}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createPaymentReconMain = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/paymentreconmain/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updatePaymentReconMain = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/paymentreconmain/${encodeURIComponent(id)}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deletePaymentReconMain = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/paymentreconmain/${encodeURIComponent(id)}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const generatePaymentReconReport = (params) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/paymentreconmain/report`, params, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
